import { useState, useEffect } from 'react';

const ProgressButton = () => {
  const [scrollProgress, setScrollProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Calculate scroll percentage
      const scrollPercentage = (scrollTop / (documentHeight - windowHeight)) * 100;
      setScrollProgress(scrollPercentage);
      
      // Show button after scrolling 300px
      setIsVisible(scrollTop > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Calculate circle dashoffset (circumference = 2 * π * r = 2 * 3.14159 * 24 ≈ 150.8)
  const circumference = 150.8;
  const offset = circumference - (scrollProgress / 100) * circumference;

  return (
    <button
      onClick={scrollToTop}
      className={`progress-btn fixed bottom-8 right-8 w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center transition-all duration-300 z-50 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16 pointer-events-none'
      }`}
      aria-label="Scroll to top"
    >
      {/* SVG for circular progress */}
      <svg className="progress-circle absolute inset-0" width="50" height="50" viewBox="0 0 50 50">
        {/* Background circle */}
        <circle 
          className="progress-circle-bg" 
          cx="25" 
          cy="25" 
          r="24" 
          fill="none" 
          stroke="#e6e6e6" 
          strokeWidth="2"
        />
        {/* Progress circle */}
        <circle 
          className="progress-circle-path" 
          cx="25" 
          cy="25" 
          r="24" 
          fill="none" 
          stroke="#0a71ee" 
          strokeWidth="2"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform="rotate(-90 25 25)"
          style={{ transition: 'stroke-dashoffset 0.1s ease' }}
        />
      </svg>
      {/* Arrow icon */}
      <svg 
        className="arrow-icon relative z-10" 
        width="20" 
        height="20" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <polyline points="18 15 12 9 6 15"></polyline>
      </svg>
    </button>
  );
};

export default ProgressButton;
